import React from "react";

const Gradients = () => {
  return (
    <svg style={{ height: '0px', width: '0px' }}>
      <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#F55F1B" />
          <stop offset="100%" stopColor="#F79837" />
        </linearGradient>
        <linearGradient id="gradient2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FF796F" />
          <stop offset="100%" stopColor="#FFB7B2" />
        </linearGradient>
        <linearGradient id="gradient3" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#2664B4" />
          <stop offset="100%" stopColor="#1E87A5" />
        </linearGradient>
        <linearGradient id="gradientInner1" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#f5a623" />
          <stop offset="100%" stopColor="#ffca75" />
        </linearGradient>
        <linearGradient id="gradientInner2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#e6dee9" />
          <stop offset="100%" stopColor="#fdcaf1" />
        </linearGradient>
        <linearGradient id="gradientInner3" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#c2e9fb" />
          <stop offset="100%" stopColor="#a1c4fd" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Gradients;
